/* RESPONSIBLE TEAM: team-reporting */
import Model, { attr } from '@ember-data/model';

export default class ChartModel extends Model {
  @attr('string') dashboard_identifier;
  @attr('string') chart_identifier;
  @attr('string') aggregation_method;
  @attr('string') grouping_method;
}
